import memoize from 'lodash/memoize';
import {checkRut, cleanRut, formatRut} from "./rut/rut";

export const isString = (str) => {
  return typeof str === 'string';
};

export const isEmptyString = (str) => {
  return str === null || str === undefined || str.toString().trim().length === 0;
};

export const isNullOrUndefined = (value) => {
  return value === null || value === undefined;

};

export const isEmptyObject = (obj) => {
  if (isNullOrUndefined(obj)) return true;

  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
};

export const isSuccessResponse = (response) => {
  return !!(response && response.data && response.status < 400);
};

export const rut = {
  checkRut: checkRut,
  clean: cleanRut,
  format: formatRut,
  checkNativeRut: memoize((value) => {
    const {bodyPart} = checkRut(value);
    return !!(bodyPart && +bodyPart < 50000000);
  }),
  checkLegalRut: memoize((value) => {
    const {bodyPart} = checkRut(value);
    return !!(bodyPart && +bodyPart > 50000000);
  })
};

export const isOtherBillUser = (value) => value?.nombre === 'OTRO';
export const isPlanFull = (plan) => plan?.type === 'FULL';
export const isPlanBasic = (plan) => plan?.type === 'BASICO';

export * from './yup/yup-phone-validator/yup-phone';
